export default "__VITE_ASSET__B07Gvaap__"